import { Icon } from '@iconify/react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState, useEffect } from 'react';
import { firestore } from '../../../../contexts/FirebaseContext';
import useUserListRole from '../../../../hooks/useUserListRole';
import UserForm from './UserForm';
import { LoadingButton } from '@mui/lab';
import { roles as ROLES } from '../../../../constants/roles';
import { useForm } from 'react-hook-form';
import useAuth from '../../../../hooks/useAuth';
import AbonosCargos from './section-1/AbonosCargos';
import UserWalletInfo from './section-1/UserWalletInfo';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PersonIcon from '@mui/icons-material/Person';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import SelectOptionLayout, { SideItem } from '../../../../layouts/components/SelectOptionLayout';
import Section4 from './section-4/Section4';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import useWalletVerif from '../../../../hooks/useWalletVerif';
import Section5 from './section-5/Section5';
import UserRoles from './section-3/UserRoles';
import Section6 from './section-6/Section6';
import Section7 from './section-7/Section7';
import HistorialSection from './section-1/historialEmpaque/HistorialSection';
import DescuentosUsers from './section-8/DescuentosUsers';
import ListaDescuentoPaq from './section-8/ListaDescuentoPaq';
import ContratoLicenciatario from './section-9/ContratoLicenciatario';
import { useLocation } from 'react-router';
import UtilidadesUsuario from './section-10/UtilidadesUsuario';

function DialogUsuarioEditar({ open, onClose, data }) {
  const [section, setSection] = useState(1);
  const { user } = useAuth();
  const { walletExist } = useWalletVerif(data.id);
  const { pathname, hash, key, search, state } = useLocation();

  const handleClose = () => {
    onClose(false);
  };

  console.log('el usuario', data);
  // console.log(pathname, hash, key, search, state);

  const side = (
    <>
      <SideItem text="Abonos, cargos y wallet" section={1} action={setSection} icon={<AccountBalanceWalletIcon />} />
      <SideItem text="Datos del usuario" section={2} action={setSection} icon={<PersonIcon />} />
      {pathname.includes('olimpo') && (
        <SideItem text="Editar rol" section={3} action={setSection} icon={<DomainVerificationIcon />} />
      )}
      {!['cajero', 'cliente-corporativo'].includes(data.role) && (
        <SideItem text="Asignar usuarios" section={4} action={setSection} icon={<DomainVerificationIcon />} />
      )}
      {['cajero', 'cliente-corporativo'].includes(data.role) && (
        <SideItem text="Host user" section={5} action={setSection} icon={<DomainVerificationIcon />} />
      )}
      {/* <SideItem text="Empaque usuario" section={6} action={setSection} icon={<AccountBalanceWalletIcon />} /> */}
      {/* <SideItem text="Crece" section={7} action={setSection} icon={<AccountBalanceWalletIcon />} /> */}
      {['cliente-corporativo', 'almighty'].includes(data.role) && (
        <SideItem text="Descuento" section={8} action={setSection} icon={<AccountBalanceWalletIcon />} />
      )}
      <SideItem text="Contratos" section={9} action={setSection} icon={<AccountBalanceWalletIcon />} />
      <SideItem text="Utilidades" section={10} action={setSection} icon={<AccountBalanceWalletIcon />} />
    </>
  );

  const body = (
    <>
      {section === 1 && (
        <>
          {walletExist && (
            <>
              <Grid item xs={12}>
                <AbonosCargos adminId={user.id} data={data} />
              </Grid>
              <Grid item xs={12}>
                <UserWalletInfo data={data} />
              </Grid>
              <Grid item xs={12}>
                <HistorialSection data={data} />
              </Grid>
            </>
          )}
          {!walletExist && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" textAlign="center">
                Este usuario aun no ha inicializado su wallet
              </Typography>
            </Grid>
          )}
        </>
      )}
      {section === 2 && (
        <Grid item xs={12}>
          <Card sx={{ padding: '15px' }}>
            <UserForm user={data} />
          </Card>
        </Grid>
      )}
      {section === 3 && (
        <Grid item xs={12}>
          <UserRoles adminId={user.id} data={data} />
        </Grid>
      )}
      {section === 4 && (
        <Grid item xs={12}>
          <Section4 dataUser={data} />
        </Grid>
      )}
      {section === 5 && (
        <Grid item xs={12}>
          <Section5 dataUser={data} />
        </Grid>
      )}
      {/* {section === 6 && (
        <Grid item xs={12}>
          <Section6 dataUser={data} />
        </Grid>
      )} */}
      {section === 7 && (
        <Grid item xs={12}>
          <Section7 dataUser={data} />
        </Grid>
      )}
      {section === 8 && (
        <Grid item xs={12}>
          {/* <DescuentosUsers dataUser={data} /> */}
          <ListaDescuentoPaq dataUser={data} />
        </Grid>
      )}
      {section === 9 && (
        <Grid item xs={12}>
          {/* <DescuentosUsers dataUser={data} /> */}
          <ContratoLicenciatario dataUser={data} />
        </Grid>
      )}
      {section === 10 && (
        <Grid item xs={12}>
          {/* <DescuentosUsers dataUser={data} /> */}
          <UtilidadesUsuario dataUser={data} />
        </Grid>
      )}
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Detalle del usuario</DialogTitle>
      <DialogContent sx={{ marginTop: '15px', minHeight: '70vh' }}>
        <SelectOptionLayout sidebar={side} body={body} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Volver
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogUsuarioEditar;

// const ROLES = [
//   'usuario',
//   'repartidor',
//   'operativo',
//   'administrativo ',
//   'cliente-licenciatario',
//   'lite',
//   'basic',
//   'plus',
//   'superusuario',
//   'dios'
// ];

// function UserRoles({ data, adminId }) {
//   const [rol, setRol] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const [roles, setRoles] = useState([]);
//   const role = useUserListRole(data.id);
//   const { enqueueSnackbar } = useSnackbar();
//   const { currentUser } = useAuthUsers();
//   const roleName = currentUser?.role;

//   console.log('mi rol actual', roleName);
//   // console.log('roles local', ROLES);

//   const handleRol = (e) => {
//     setRol(e.target.value);
//   };

//   const submitRol = async () => {
//     if (roleName === 'superusuario' || roleName === 'almighty') {
//       setLoading(true);
//       if (rol === 'almighty' && roleName === 'almighty') {
//         try {
//           await firestore.collection('users').doc(data.id).update({ role: rol });

//           enqueueSnackbar('Rol actualizado', { variant: 'success' });
//           setLoading(false);
//           setOpenConfirm(false);
//         } catch (error) {
//           console.log(error.response);
//           setLoading(false);
//           enqueueSnackbar('Se produjo un error', { variant: 'error' });
//           setOpenConfirm(false);
//         }
//       } else if (roleName !== 'almighty' && rol === 'almighty') {
//         enqueueSnackbar('Solo un usuario con rol de Almighty puede dar credenciales de Almighty a otro', {
//           variant: 'error'
//         });
//         setLoading(false);
//       } else if (roleName !== 'almighty' && role === 'almighty') {
//         enqueueSnackbar('Solo un usuario con rol de Almighty puede dar credenciales de Almighty a otro', {
//           variant: 'error'
//         });
//         setLoading(false);
//       } else {
//         try {
//           await firestore.collection('users').doc(data.id).update({ role: rol });

//           enqueueSnackbar('Rol actualizado', { variant: 'success' });
//           setLoading(false);
//           setOpenConfirm(false);
//         } catch (error) {
//           console.log(error.response);
//           setLoading(false);
//           enqueueSnackbar('Se produjo un error', { variant: 'error' });
//           setOpenConfirm(false);
//         }
//       }
//     } else {
//       enqueueSnackbar('Solo un super usuario puede hacer el cambio de roles', { variant: 'error' });
//     }
//   };

//   useEffect(() => {
//     setRol(role);
//   }, [role]);

//   useEffect(() => {
//     firestore.collection('roles').onSnapshot((snapshot) => {
//       const roles = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setRoles(roles);
//     });
//   }, []);
//   return (
//     <Card sx={{ padding: '15px' }}>
//       <Box marginTop="15px" display="flex" flexDirection="column">
//         <FormControl>
//           <FormLabel id="demo-radio-buttons-group-label">Roles</FormLabel>
//           <RadioGroup
//             aria-labelledby="demo-radio-buttons-group-label"
//             defaultValue="female"
//             name="radio-buttons-group"
//             value={rol}
//             onChange={handleRol}
//           >
//             {roles.map((rol) => (
//               <FormControlLabel
//                 onClick={() => setOpenConfirm(true)}
//                 key={rol.id}
//                 value={rol.id}
//                 control={<Radio />}
//                 label={rol.displayName}
//               />
//             ))}
//             {/* <FormControlLabel value="male" control={<Radio />} label="Cliente-licenciatario" />
//             <FormControlLabel value="other" control={<Radio />} label="Usuario" /> */}
//           </RadioGroup>
//         </FormControl>
//         <Box marginTop="15px" display="flex" gap="10px">
//           {/* <Button variant="contained" color="error" onClick={() => setOpenConfirm(true)}>
//             Guardar nuevo rol
//           </Button> */}
//           <ConfirmDialog
//             open={openConfirm}
//             onClose={setOpenConfirm}
//             submitRol={submitRol}
//             loading={loading}
//             adminId={adminId}
//             setLoading={setLoading}
//           />
//           {/* <Button onClick={() => setUpdateRol(false)} variant="contained" color="info">
//             Cerrar
//           </Button> */}
//         </Box>
//       </Box>
//     </Card>
//   );
// }

// function ConfirmDialog({ open, onClose, submitRol, loading, setLoading, adminId }) {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors }
//   } = useForm();
//   const { enqueueSnackbar } = useSnackbar();
//   const handleClose = () => {
//     onClose(false);
//   };

//   const acceptSubmit = async (data) => {
//     console.log(data);
//     setLoading(true);
//     let userNip;
//     await firestore
//       .collection('users')
//       .doc(adminId)
//       .get()
//       .then((doc) => {
//         userNip = doc.data().nip;
//       })
//       .catch((error) => {
//         console.log(error.response);
//         // setLoading(true);
//         enqueueSnackbar('Se ha producido un error', { variant: 'error' });
//         setLoading(false);
//       });

//     if (data.nip === userNip) {
//       console.log('los nip son correctos');
//       submitRol();
//     } else {
//       setLoading(false);
//       enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
//     }
//   };
//   return (
//     <Dialog open={open} onClose={handleClose}>
//       <DialogTitle>Esta seguro que desea cambiar el rol de este usuario</DialogTitle>
//       <DialogContent>
//         <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(acceptSubmit)}>
//           <Box marginBottom="15px">
//             <TextField
//               type="password"
//               fullWidth
//               {...register('nip', { required: true })}
//               variant="outlined"
//               label="NIP"
//             />
//             {errors.nip && (
//               <Typography color="error" fontSize="13px">
//                 Ingrese su NIP
//               </Typography>
//             )}
//           </Box>
//           {/* <Box marginBottom="15px">
//             <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
//             {errors.message && (
//               <Typography color="error" fontSize="13px">
//                 Ingrese un mensaje
//               </Typography>
//             )}
//           </Box> */}
//           <LoadingButton loading={loading} fullWidth variant="contained" type="submit">
//             Cambiar rol
//           </LoadingButton>
//         </Card>
//       </DialogContent>
//       <DialogActions>
//         {/* <LoadingButton loading={loading} variant="contained" color="info" onClick={submitRol}>
//           Aceptar
//         </LoadingButton> */}

//         <Button onClick={handleClose} startIcon={<Icon icon="eva:arrow-back-fill" />}>
//           Volver
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }
